import React, { useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import { Formik, Form as FormikForm, Field } from "formik";
import DateTimePicker from "react-datetime-picker";
import {
  serviceActions,
  useServiceReducer,
} from "../../reducers/serviceReducer";
import { analyze } from "../../services/Engine";
import { insertTrainingData } from "../../services/Settings";

export default function DataAppender() {
  const { addToast } = useToasts();
  const [date, setDate] = useState(new Date());

  const [sentimentResult, setSentimentResult] = useState({
    code: null,
    sentiment: null,
  });
  const [buttonTitle, setButtonTitle] = useState("Submit");
  const [serviceState, serviceDispatch] = useServiceReducer();
  const sources = [
    "Instagram",
    "Facebook",
    "Twitter",
    "Website",
    "News Channel",
    "Report",
    "Presentation",
    "Other",
  ];

  async function saveData(values, resetForm) {
    values.date = date;

    serviceDispatch({ type: serviceActions.LOADING });
    setSentimentResult(null);
    setButtonTitle("Contacting analysis engine...");

    try {
      const result = await analyze('comprehend',{
        text: values.summary,
        testOnly: true,
      });
      serviceDispatch({ type: serviceActions.SUCCESS });

      values.aws_sentiment = updateSentimentAnalysis(result.analysis);
      setButtonTitle("Adding training data...");

      serviceDispatch({ type: serviceActions.LOADING });
      const finalResult = await insertTrainingData(values);

      console.log("final result", finalResult);
      addToast("Training data successfully added", {
        appearance: "success",
      });
      serviceDispatch({ type: serviceActions.SUCCESS });
    } catch (err) {
      console.log("error", err);
      serviceDispatch({ type: serviceActions.ERROR, payload: err.message });
      addToast(`System error: ${err.message}`, { appearance: "error" });
      return;
    } finally {
      setButtonTitle("Submit");
      resetForm();
      values.aws_sentiment = updateSentimentAnalysis(null);
    }
  }

  function updateSentimentAnalysis(engineResult) {
    if (engineResult && engineResult.Sentiment) {
      switch (engineResult.Sentiment) {
        case "NEGATIVE":
          setSentimentResult({ code: -1, sentiment: "Negative" });
          return -1;
        case "NEUTRAL":
          setSentimentResult({ code: 0, sentiment: "Neutral" });
          return 0;
        case "POSITIVE":
          setSentimentResult({ code: 1, sentiment: "Positive" });
          return 1;
        default:
          setSentimentResult({ code: null, sentiment: null });
          return null;
      }
    } else {
      setSentimentResult({ code: null, sentiment: null });
      return null;
    }
  }
  function SentimentResultDisplay() {
    if (sentimentResult) {
      return sentimentResult.sentiment;
    } else {
      return (
        <Form.Text className="text-muted">
          Amazon Comprehend Analysis Engine performs its own sentiment analysis
          once you submit this form.
        </Form.Text>
      );
    }
  }
  function DataLoaderForm() {
    return (
      <div className="card mb-4">
        <div className="card-body">
          <Formik
            initialValues={{
              source: "",
              title: "",
              summary: "",
              text: "",
              sentiment: "0",
              significance: "-1",
            }}
            onSubmit={(values, { resetForm }) => {
              saveData(values, resetForm);
            }}
          >
            {({ values }) => (
              <FormikForm>
                <Form.Row>
                  <Form.Group className="ml-2" as={Col} controlId="form.source">
                    <Form.Label>Source</Form.Label>
                    <Field
                      className="form-control"
                      name="source"
                      as="select"
                      value={values.source}
                      placeholder="Select source"
                    >
                      <option value="">Select source</option>
                      {sources.sort().map(function (s) {
                        return (
                          <option key={`opt_${s}`} value={s}>
                            {s}
                          </option>
                        );
                      })}
                    </Field>
                  </Form.Group>
                  <Form.Group className="" as={Col} controlId="form.date">
                    <Form.Label>Date</Form.Label>
                    <DateTimePicker
                      maxDetail="second"
                      className="form-control"
                      onChange={setDate}
                      value={date}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group
                    className="ml-2 mr-2"
                    as={Col}
                    controlId="exampleForm.ControlTitle"
                  >
                    <Form.Label>Content Title</Form.Label>
                    <Field
                      className="form-control"
                      id="title"
                      name="title"
                      placeholder="Title in English"
                      type="text"
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group
                    className="ml-2 mr-2"
                    as={Col}
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Content Text</Form.Label>
                    <Field
                      className="form-control"
                      component="textarea"
                      rows="10"
                      id="text"
                      name="text"
                      placeholder="Text in English"
                      type="textarea"
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group
                    className="ml-2 mr-2"
                    as={Col}
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Content Summary</Form.Label>
                    <Field
                      className="form-control"
                      component="textarea"
                      rows="10"
                      id="summary"
                      name="summary"
                      placeholder="Summary in English"
                      type="textarea"
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group className="ml-2" as={Col}>
                    <Form.Label>Significance</Form.Label>
                    <div>
                      <label className="mr-2">
                        <Field
                          type="radio"
                          className="mr-1"
                          name="significance"
                          value="-1"
                        />
                        Low
                      </label>
                      <label className="mr-2">
                        <Field
                          className="mr-1"
                          type="radio"
                          name="significance"
                          value="0"
                        />
                        Medium
                      </label>
                      <label className="mr-2">
                        <Field
                          className="mr-1"
                          type="radio"
                          name="significance"
                          value="1"
                        />
                        High
                      </label>
                    </div>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group className="ml-2" as={Col}>
                    <Form.Label>Sentiment</Form.Label>
                    <div>
                      <label className="mr-2">
                        <Field
                          type="radio"
                          className="mr-1"
                          name="sentiment"
                          value="-1"
                        />
                        Negative
                      </label>
                      <label className="mr-2">
                        <Field
                          className="mr-1"
                          type="radio"
                          name="sentiment"
                          value="0"
                        />
                        Neutral
                      </label>
                      <label className="mr-2">
                        <Field
                          className="mr-1"
                          type="radio"
                          name="sentiment"
                          value="1"
                        />
                        Positive
                      </label>
                    </div>
                    <div>
                      <label>Sentiment Analysis Engine Result</label>
                    </div>

                    <SentimentResultDisplay />
                  </Form.Group>
                </Form.Row>
                <Button
                  type="submit"
                  className="ml-2 mb-2"
                  variant="outline-primary"
                  disabled={
                    !values.source.trim().length ||
                    !date ||
                    !values.text ||
                    !values.text.trim().length ||
                    !values.summary ||
                    !values.summary.trim().length ||
                    serviceState.loading
                  }
                >
                  {buttonTitle}
                </Button>
              </FormikForm>
            )}
          </Formik>
        </div>
      </div>
    );
  }

  return <DataLoaderForm />;
}
